import React from "react";
import { ResponsiveLine } from "@nivo/line";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
export const LineChart = ({
  axisBottomLegend,
  ...props
}: any): React.ReactElement => (
  <ResponsiveLine
    margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
    xScale={{ type: "linear" }}
    yScale={{
      type: "linear",
      min: "auto",
      max: "auto",
    }}
    curve="linear"
    axisBottom={{
      legend: axisBottomLegend,
      orient: "bottom",
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legendOffset: 40,
      legendPosition: "middle",
    }}
    axisLeft={{
      orient: "left",
      tickSize: 5,
      tickPadding: 5,
      legend: props.axisLeftLegend,
      legendOffset: -53,
      legendPosition: "middle",
    }}
    colors={{ scheme: "category10" }}
    pointSize={12}
    pointColor={{ theme: "background" }}
    pointBorderWidth={2}
    pointBorderColor={{ from: "serieColor" }}
    pointLabel="y"
    pointLabelYOffset={-12}
    useMesh={true}
    legends={[
      {
        anchor: "bottom-right",
        direction: "column",
        justify: false,
        translateX: 100,
        translateY: 0,
        itemsSpacing: 0,
        itemDirection: "left-to-right",
        itemWidth: 80,
        itemHeight: 20,
        itemOpacity: 0.75,
        symbolSize: 12,
        symbolShape: "circle",
        symbolBorderColor: "rgba(0, 0, 0, .5)",
        effects: [
          {
            on: "hover",
            style: {
              itemBackground: "rgba(0, 0, 0, .03)",
              itemOpacity: 1,
            },
          },
        ],
      },
    ]}
    {...props}
  />
);

export * from "./LineChartTimeline";
